var map = {
	"./ca.json": 77045,
	"./de-AT.json": 85792,
	"./de-DE.json": 85030,
	"./el.json": 58660,
	"./en-GB.json": 35492,
	"./en-IE.json": 29267,
	"./en.json": 43542,
	"./es.json": 7069,
	"./fr.json": 83877,
	"./it.json": 27264,
	"./pl.json": 79005,
	"./pt.json": 23077,
	"./ro.json": 85146,
	"./sv.json": 6868
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36146;